<template>
  <div
    class="col-11 col-lg-6 d-flex w-md-50 align-items-center justify-content-center py-4 py-md-0 my-5"
  >
    <div>
      <div
        v-if="isConnectedDomain ? (stationData.connectedNameDomainAltitudeDiff || stationData.altitudeDiff) : stationData.altitudeDiff"
        class="position-relative"
        style="width: 290px"
        id="station-logo-container"
      >
        <!-- STATIONS VERTICAL -->
        <div
          id="stations-vertical"
          class="body text-grey-900 position-absolute text-start"
        >
          <div class="d-flex gap-1">
            <!-- TEXT -->
            <div class="d-flex flex-column justify-content-center">
              <span class="body-strong text-grey-900">
                {{ content.station_Vertical }}
              </span>
              <span class="body text-grey-700">
                {{ isConnectedDomain ? (stationData.connectedNameDomainAltitudeDiff || stationData.altitudeDiff) : stationData.altitudeDiff }}
                {{ content.station_Metres }}
              </span>
            </div>
            <!-- END TEXT -->
            <!-- ICON -->
            <svg style="color: var(--primary-green);" width="8" height="111" fill="none">
                  <use href="#___icon___vertical-green-dots-line"></use>
            </svg>
            <!-- END ICON -->
          </div>
        </div>
        <!-- END STATIONS VERTICAL -->
        <!-- MOUNTAINS -->
        <div class="position-absolute">
            <svg style="color: var(--primary-blue);" width="112" height="100" fill="none">
                  <use href="#___icon___two-mountains"></use>
            </svg>
        </div>
        <!-- END MOUNTAINS -->
        <!-- SUMMIT -->
        <div
          id="summit-container"
          class="body text-grey-900 position-absolute text-end"
        >
          <div class="d-flex gap-1">
            <!-- ICON -->
            <svg style="color: var(--primary-green);" width="56" height="8" fill="none">
                  <use href="#___icon___horizontal-green-dots-line"></use>
            </svg>
            <!-- END ICON -->
            <!-- TEXT -->
            <div class="d-flex flex-column gap-1 text-start">
              <span class="body-strong text-grey-900">
                {{ content.station_Height }}
              </span>
              <span class="body text-grey-700">
                {{ isConnectedDomain ? (stationData.connectedNameDomainMaxAltitude || stationData.maxAltitude) : stationData.maxAltitude }}
                {{ content.station_Metres }}
              </span>
            </div>
            <!-- END TEXT -->
          </div>
        </div>
        <!-- END SUMMIT -->
        <!-- STATION DISTANCE -->
        <div
          id="station-distance-container"
          class="body text-grey-900 position-absolute text-end"
        >
          <div class="d-flex gap-1">
            <!-- ICON -->
            <svg style="color: var(--primary-green);" width="56" height="8" fill="none">
                  <use href="#___icon___horizontal-green-dots-line"></use>
            </svg>
            <!-- END ICON -->
            <!-- TEXT -->
            <div class="d-flex flex-column gap-1 text-start">
              <span class="body-strong text-grey-900">
                {{ content.station_Resort }}
              </span>
              <span class="body text-grey-700">
                {{ isConnectedDomain ? (stationData.connectedNameDomainMinAltitude || stationData.minAltitude) : stationData.minAltitude }}
                {{ content.station_Metres }}
              </span>
            </div>
            <!-- END TEXT -->
          </div>
        </div>
        <!-- END STATION DISTANCE -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Define types for the props
interface MountainInfoLogoProps {
  data: Record<string, any>;
  stationData: Record<string, any>;
  content: Record<string, string>;
  isConnectedDomain: boolean;
}

// Props
const props = defineProps<MountainInfoLogoProps>();

// Add warnings for fallback data
import { onMounted } from 'vue';

onMounted(() => {
  
  if (props.isConnectedDomain) {
    // Check if any fallbacks are being used
    const usingFallbacks = 
      (!props.stationData.connectedNameDomainAltitudeDiff && props.stationData.altitudeDiff) ||
      (!props.stationData.connectedNameDomainMaxAltitude && props.stationData.maxAltitude) ||
      (!props.stationData.connectedNameDomainMinAltitude && props.stationData.minAltitude);
    
    if (usingFallbacks) {
      console.warn('MountainInfoLogo: Using fallback data for connected domain (altitude, max/min heights)');
    }
  }
  
  // Check if any required data is missing
  const missingData = [];
  if (!props.stationData.altitudeDiff) missingData.push('altitudeDiff');
  if (!props.stationData.maxAltitude) missingData.push('maxAltitude');
  if (!props.stationData.minAltitude) missingData.push('minAltitude');
  
  if (missingData.length > 0) {
    console.warn('MountainInfoLogo: Missing required data:', missingData);
  }
});
</script>

<style scoped></style>
